import React from 'react';

export default class Tile extends React.Component {
  getRotationClass() {
    switch(this.props.orientation) {
      case "UP":
        return "up";
      case "RIGHT":
        return "right";
      case "DOWN":
        return "down";
      case "LEFT":
        return "left";
      default:
        return "right";
    }
  }

  render() {
    const actorImage = this.props.actorImage && <div className="actor">
      <img src={this.props.actorImage} alt=""/>
    </div>

    const itemImage = this.props.itemImage && <div className="item">
      <img src={this.props.itemImage} alt=""/>
    </div>

    const enemyImage = this.props.enemyImage && <div className="enemy">
      <img src={this.props.enemyImage} alt=""/>
    </div>
    
    return (
      <div
        className={"square " + this.props.className}
        onClick={this.props.onClick}
      >
        {actorImage}
        {itemImage}
        {enemyImage}
        <img src={this.props.image} className={this.getRotationClass()} data-tip={this.props.toolTip} alt=""></img>
      </div>
    );
  }
}
